'use client';
import { createContext, FC, useContext } from 'react';
import { type TypeKeyValueListFields } from '@/core/generated-types';
import type { Entry } from 'contentful';
import generateTranslationsObject from '@/utils/translations/generateTranslationObject';

type PageTranslationsContextValue = { [key: string]: string };

interface PageTranslationProps {
  children: any;
  translations?: Entry<TypeKeyValueListFields>;
}

const PageTranslationContext = createContext(
  {} as PageTranslationsContextValue,
);

export const usePageTranslations = () => useContext(PageTranslationContext);

export const PageTranslationsProvider: FC<PageTranslationProps> = ({
  translations,
  children,
}) => {
  const formattedTranslations = generateTranslationsObject(
    translations?.fields,
  );

  return (
    <PageTranslationContext.Provider value={formattedTranslations}>
      {children}
    </PageTranslationContext.Provider>
  );
};
